<script>
  // Replaces react-bootstrap's <Form.Check type="switch">. Controlled: parent owns `checked`.
  let { checked = false, disabled = false, onchange } = $props();
</script>

<button
  type="button"
  role="switch"
  aria-checked={checked}
  class="toggle"
  class:on={checked}
  {disabled}
  onclick={() => onchange?.(!checked)}
>
  <span class="knob"></span>
</button>

<style>
  .toggle {
    width: 40px; height: 22px; border-radius: 999px; border: none; cursor: pointer;
    background: var(--border); position: relative; transition: background 0.15s; padding: 0;
  }
  .toggle.on { background: var(--accent); }
  .toggle:disabled { opacity: 0.45; cursor: not-allowed; }
  .knob {
    position: absolute; top: 2px; left: 2px; width: 18px; height: 18px; border-radius: 50%;
    background: #fff; transition: transform 0.15s;
  }
  .toggle.on .knob { transform: translateX(18px); }
</style>
